import { useEffect } from "react";

/**
 * useSeo — Set the page <title> and <meta name="description">, plus Open Graph
 * fallbacks. Runs on mount + whenever the title/description change. Restores
 * the previous title on unmount so client-side navigation stays clean.
 */
const upsertMeta = (attr, value, content) => {
  if (!content) return null;
  let el = document.head.querySelector(`meta[${attr}="${value}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, value);
    document.head.appendChild(el);
  }
  const previous = el.getAttribute("content");
  el.setAttribute("content", content);
  return () => {
    if (previous == null) {
      el.remove();
    } else {
      el.setAttribute("content", previous);
    }
  };
};

export const useSeo = ({ title, description, ogImage }) => {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;
    const restorers = [
      description && upsertMeta("name", "description", description),
      title && upsertMeta("property", "og:title", title),
      description && upsertMeta("property", "og:description", description),
      ogImage && upsertMeta("property", "og:image", ogImage),
    ].filter(Boolean);
    return () => {
      document.title = prevTitle;
      restorers.forEach((fn) => fn());
    };
  }, [title, description, ogImage]);
};
